// Dual screen role for this device (Settings). Saved through its own endpoint, not the settings form.
// Delegated handlers: they work however and whenever the card is put on the page.
$(document).ready(function () {
  function toggleDualScreenFields($card) {
    const role = $card.find('#dual-screen-role').val();
    $card.find('.dual-screen-master-field').prop('hidden', role !== 'master');
    $card.find('.dual-screen-slave-field').prop('hidden', role !== 'slave');
    if (role === 'slave' && !$card.data('mastersLoaded')) {
      loadDualScreenMasters($card);
    }
  }

  function loadDualScreenMasters($card) {
    const $masterSelect = $card.find('#dual-screen-master');
    $.ajax({
      type: 'GET',
      url: '/api/v1/private/dual-screen/masters',
      cache: false,
    }).done(function (data) {
      $card.data('mastersLoaded', true);
      $masterSelect.find('option:not(:first)').remove();
      (data.masters || []).forEach(function (master) {
        if (master.is_current_device) {
          return;
        }
        $masterSelect.append(
          $('<option>').val(master.dual_screen_device_id).text(master.master_name)
        );
        if (master.is_paired) {
          $masterSelect.val(master.dual_screen_device_id);
        }
      });
    });
  }

  function saveDualScreen($card, replaceSlave) {
    const $button = $card.find('#dual-screen-save').prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/dual-screen/settings',
      data: {
        screen_role: $card.find('#dual-screen-role').val(),
        master_name: $card.find('#dual-screen-master-name').val(),
        master_dual_screen_device_id: $card.find('#dual-screen-master').val(),
        replace_slave: replaceSlave ? 1 : 0,
      },
    })
      .done(function (data) {
        $card.attr('data-role', $card.find('#dual-screen-role').val());
        showToast({
          type: 'success',
          title: '',
          message: data.message,
          position: 'top-right',
          duration: 3000,
        });
      })
      .fail(function (xhr) {
        const data = xhr.responseJSON || {};
        if (data.redirect_url) {
          window.location.href = data.redirect_url;
          return;
        }
        if (data.confirm_replace && window.confirm(data.message)) {
          saveDualScreen($card, true);
          return;
        }
        showToast({
          type: 'error',
          title: '',
          message: data.message || 'Error ' + xhr.status,
          position: 'top-right',
          duration: 4000,
        });
      })
      .always(function () {
        $button.prop('disabled', false);
      });
  }

  $(document).on('change', '#dual-screen-role', function () {
    toggleDualScreenFields($(this).closest('#dual-screen-settings'));
  });

  $(document).on('click', '#dual-screen-save', function (e) {
    e.preventDefault();
    saveDualScreen($(this).closest('#dual-screen-settings'), false);
  });

  $('#dual-screen-settings').each(function () {
    toggleDualScreenFields($(this));
  });
});
